import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Topbar.module.css";
import { CiMenuKebab } from "react-icons/ci";
import { CiMenuBurger } from "react-icons/ci";
import { AiOutlineFullscreen, AiOutlineFullscreenExit } from "react-icons/ai";
import logo from "../../Assets/images/logo.png";
import LangaugeSelector from "../languageSelector/LangaugeSelector";
import ThemeToggler from "../ThemeToggler/ThemeToggler";
import { useDispatch, useSelector } from "react-redux";
import { adminLogout } from "../../Store/Slices/AdminSlice";
import { MdNotifications, MdOutlineShoppingCart } from "react-icons/md";
import { MdNotificationsActive } from "react-icons/md";
// import { messaging, getToken, onMessage } from "@/firebase.js";
import LoaderContext from "../loader";
import { FaCartShopping } from "react-icons/fa6";
import { MasterApi } from "../../App/api/setting";
// import { messaging, getToken, onMessage } from "../../service/firebase.js";


function TopBar({ handleSideBar }) {
  // const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const {currentUser,loading}=useSelector((state)=>state.store)
  const { handleLoading } = useContext(LoaderContext);
  const notificationRef = useRef(null);
  const [isNotification, setIsNotification] = useState(false);
  const [notification, setNotification] = useState(false);


  useEffect(() => {
    if (isNotification) {
      setNotification(true);
    }
  }, [isNotification]);
  useEffect(() => {
    const handleMouseLeave = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.relatedTarget)
      ) {
        setNotification(false);
      }
    };
    const handleMouseClick = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setNotification(false);
      }
    };

    const notificationDiv = notificationRef.current;

    document.addEventListener("mousedown", handleMouseClick);

    if (notificationDiv) {
      notificationDiv.addEventListener("mouseleave", handleMouseLeave);
    } else {
      setNotification(false);
    }

    return () => {
      if (notificationDiv) {
        notificationDiv.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, [notification]);
  // console.log("currentUser",currentUser,loading);

  
  const [logoutDropdown,setLogoutDropdown]= useState(false);
  const { theme } = useSelector((state) => state.theme);

  const logoutRef = useRef();
  const imgRef = useRef();

  window.addEventListener("click", (e) => {
    if (e.target !== logoutRef.current && e.target !== imgRef.current) {
      setLogoutDropdown(false);
    }
  });

  const dispatch = useDispatch();

  const handleLogout = async () => {
    const payload = { payload: null, token: false };
    dispatch(adminLogout(payload));
  };

  function toggleFullScreen() {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  }

  //notification
  // const requestPermission = async (userId) => {
  //   try {
  //     const registration = await navigator.serviceWorker.register(
  //       "/firebase-messaging-sw.js"
  //     );
  //     console.log("Service Worker registered successfully:", registration);
 
  //     const token = await getToken(messaging, {
  //       vapidKey:
  //         "BMo02YcnmQse0hSsElAGS5uhoCqqklji5twX8Yv9YK8mGZab3BK68wnkFso0Re6Rfl8uzuLiFYc0sfmIfLkPJWk",
  //     });
 
  //     if (token) {
  //       console.log("Token received:", token);
 
  //       const payload = {
  //         user_id: userId || null,
  //         fcm_token: token,
  //         device_type: "web",
  //       };
 
  //       (async () => {
  //         handleLoading(true);
  //         try {
  //           const res = await MasterApi.master.saveFcmToken(payload);
  //           // const res = await MasterApi.saveFcmToken(payload);
  //           console.log("This is the response of the fcm token ", res.data);
  //         } catch (err) {
  //           console.log(err);
  //         } finally {
  //           handleLoading(false);
  //         }
  //       })();
  //     } else {
  //       console.log(
  //         "No registration token available. Request permission to generate one."
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error getting token:", error);
  //   }
  // };
  // useEffect(() => {
  //   try {
  //     onMessage(messaging, (payload) => {
  //       console.log("Message received. ", payload);
  //       // toast(`${payload.notification.title}`);
  //       setIsNotification(true);
  //     });
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // }, []);

  return (
    <div className={styles.topbar}>
      <div className={styles.topLeft}>
        <i onClick={handleSideBar} className={styles.icon}>
          <CiMenuKebab />
          <CiMenuBurger />
        </i>
        <LangaugeSelector />
      </div>
      <div className={styles.topCenter}>
        <img className={styles.logo} src={logo} alt="logo" />
        {/* <p style={{ fontWeight: "500", fontSize: "1.5rem" }}>eDelivery</p> */}
      </div>
      <div className={styles.topRight}>
        {/* notification button  */}
        {true && (
              <>
                {/* Notifications */}
                <div
                  className="relative text-gray-700"
                  onMouseEnter={() => {
                    setNotification(true);
                    setIsNotification(false);
                  }}
                >
                  
                  {isNotification ? (
                    <MdNotificationsActive className="text-2xl shake" />
                  ) : (
                    <MdNotifications className="text-2xl" />
                  )}

                  {notification && (
                    <div
                      className="absolute top-12 right-0 w-[20rem] bg-white shadow-lg border rounded-lg"
                      ref={notificationRef}
                    >
                      <div className="px-4 py-3 border-b">
                        <p className="font-semibold text-lg">Notifications</p>
                      </div>
                      <div className="w-full max-h-[60vh] overflow-y-auto p-4">
                        <p className="text-gray-500 text-sm italic text-center">
                          Notifications are currently unavailable.
                        </p>
                      </div>
                      <div className="px-4 py-3 border-t">
                        <button className="text-primary text-sm">
                          View all notifications
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Cart */}
                {/* <HoverCard openDelay={100} closeDelay={100}>
                  <HoverCardTrigger asChild>
                    <button className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-full hover:bg-gray-200 transition">
                      <FaCartShopping className="w-5 h-5 text-gray-700" />
                      {cartData && (
                        <p className="font-medium text-gray-700">
                          {cartData.length}
                        </p>
                      )}
                    </button>
                  </HoverCardTrigger>
                  <HoverCardContent className="w-[25rem] shadow-lg border rounded-lg bg-white">
                    <h1 className="font-bold text-xl text-center">
                      Your Orders
                    </h1>
                    {cartData.length > 0 ? (
                      <CheckoutCard
                        data={cartData}
                        modal={true}
                        category="ecomm"
                      />
                    ) : (
                      <div className="flex flex-col items-center p-4">
                        <Image
                          width={1400}
                          height={100}
                          src={no_cart}
                          alt="Empty Cart"
                          className="mb-2"
                        />
                        <p className="text-black font-semibold">
                          Your Cart is Empty
                        </p>
                        <Link href="/delivery">
                          <span className="text-primary text-sm hover:underline">
                            Shop today’s deals
                          </span>
                        </Link>
                      </div>
                    )}
                    <button
                      className="w-full mt-4 bg-primary text-white font-bold py-2 rounded-full hover:bg-white hover:text-primary border hover:border-primary transition"
                      onClick={handleCheckout}
                    >
                      Checkout
                    </button>
                  </HoverCardContent>
                </HoverCard> */}
              </>
            )}
        {/* <div className={true?[`${styles.mode} ${styles.light}`]: [`${styles.mode} ${styles.dark}`]}></div> */}
        <ThemeToggler />
        {!document.fullscreenElement ? (
          <AiOutlineFullscreen
            onClick={toggleFullScreen}
            className={styles.FullScreen}
          />
        ) : (
          <AiOutlineFullscreenExit
            onClick={toggleFullScreen}
            className={styles.FullScreen}
          />
        )}
        <div className={styles.avtarWrapper }>
          <p className={styles.avtarLabel}>{currentUser?.data?.user?.first_name}</p>
          {/* <div className={styles.avtar}></div> */}
          <img
            className={styles.avtar}
            src={logo}
            onClick={() => setLogoutDropdown(!logoutDropdown)}
            alt="logo"
            ref={imgRef}
          />
          {logoutDropdown && (
            <ul
              ref={logoutRef}
              className={`${styles.logout} ${
                theme === "light"
                  ? "hover:bg-[#f8f8f8]"
                  : "hover:bg-thirsaryColor"
              }`}
            >
              <li onClick={handleLogout} id="logout" className="font-bold text-base">
                Logout
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

export default TopBar;
